import { Dialog, DialogContent, DialogActions } from "@material-ui/core";
import {
  Button,
  DateTimeInput,
  FormWithRedirect,
  SelectInput,
  TextInput,
  useCreate,
  useNotify,
  useRefresh,
} from "react-admin";
import { FormSaveButton } from "../../components/FormSaveButton";
import { useOptions } from "../../shared/hooks/useOptions";
import { useToggler } from "../../shared/hooks/useToggler";
import { dateTimeFormatter, generateError, initInput } from "../../shared/utils";
import IconCancel from "@material-ui/icons/Cancel";
import { DeliveryStatusChoice } from "../../shared/types";
import { useState } from "react";
import { ReferenceInputSubject } from "../../components/reference-inputs/ReferenceInputSubject";
import { memoize } from "lodash";
import { getUser } from "../../authProvider";
import {Identifier, required} from "ra-core";
import {DeliveryStatusReasonField} from "../../Distribution/Delivery/DeliveryStatusReasonField";
import {DeliveryStatusOverbookingReasonField} from "./DeliveryStatusOverbookingReasonField";

interface OverbbokingConfirmButtonProps {
    selectedSegmentsIds: Identifier[],
    segementDeliveryMap: { [key: string]: any },
}

export const OverbbokingConfirmButton = (props: OverbbokingConfirmButtonProps) => {
  const user = getUser();
  const { value, setFalse, setTrue } = useToggler();
  const [fault, setFault] = useState();
  const refresh = useRefresh();
  const [create, { loading }] = useCreate();
  const notify = useNotify();
  const handleSubmit = (values: any) => {
      let segmentsMap: { [key: string]: boolean }  = {}
      for (let id of props.selectedSegmentsIds){
          segmentsMap[id.toString()] = false;
      }
      for (let id of props.selectedSegmentsIds){
          values.id = id;
          values.delivery = props.segementDeliveryMap[String(id)];
          if (
              isEmpty(values.delivery) ||
              isEmpty(values.status) ||
              isEmpty(values.stock_store) ||
              isEmpty(values.reason)
          ) {
              window.alert("Attenzione completare tutti i campi richiesti")
              return
          }

          create("delivery-states", values, {
              onSuccess: ({ data }) => {
                  let all_done = true;
                  for (let id_temp in segmentsMap){
                      if (String(id) == id_temp){
                          segmentsMap[id_temp] = true;
                      }
                      if (!segmentsMap[id_temp]){
                          all_done = false;
                      }
                  }
                  if (all_done){
                      setFalse();
                      refresh();
                      window.location.reload();
                  }
              },
              onFailure: (error) => {
                  generateError(error, notify);
              },
          });
      }


  };
  const { data: options } = useOptions("delivery-states", "GET");
  const { data: optionsTariffs } = useOptions("tariffs", "GET");


  function isEmpty(value: any) {
    return value === undefined || value === null || value === "";
  }


  return options && optionsTariffs && user && props ? (
    <>
        <Button style={{ width: "100%", marginTop: "10px" }} onClick={() => {
            setTrue()
        }}
                disabled={props.selectedSegmentsIds.length === 0}>
            <div style={{textAlign: "center", fontSize: "14px"}}>{props.selectedSegmentsIds.length !==0 ? `(${props.selectedSegmentsIds.length})`: ""} Operaz. massive</div>
        </Button>
      <Dialog open={value} maxWidth="sm" fullWidth>
        <FormWithRedirect
          resource="delivery-states"
          save={handleSubmit}
          initialValues={{ }}
          render={({ handleSubmitWithRedirect, pristine, saving, form }) => (
            <>
              <DialogContent>
                <DateTimeInput
                  initialValue={dateTimeFormatter(new Date())}
                  {...initInput("date", options, true)}
                  showTime={true}
                />
                <SelectInput
                  {...initInput("status", options, true, "array")}
                    defaultValue={DeliveryStatusChoice.SUSPENDED}
                  choices={[
                      { display_name: "Sospesa", value: DeliveryStatusChoice.SUSPENDED },
                      { display_name: "In giacenza", value: DeliveryStatusChoice.STOCKED },
                  ]}
                />
                <DeliveryStatusOverbookingReasonField
                  options={options}
                  setFault={setFault}
                  form={form}
                  isRequired={
                    [DeliveryStatusChoice.STOCKED, DeliveryStatusChoice.SUSPENDED].includes(
                      form.getState().values?.status)
                  }
                />
                <TextInput {...initInput("status_notes", options, true)} />

                <ReferenceInputSubject
                  {...initInput(
                    "stock_store",
                    true
                  )}
                  isRequired={true}
                  label="Magazzino"
                  filter={{ type: "default_store" }}
                />

              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={setFalse}>
                  <IconCancel />
                </Button>
                <FormSaveButton
                  handleSubmit={() => handleSubmitWithRedirect!()}
                  submitting={loading}
                  pristine={pristine}
                  label="Crea"
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  ) : null
};
